function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMorningReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    width: 128,
    height: 128,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,14H11V9H31ZM11,42H31V38H11ZM46,19V43a5.00181,5.00181,0,0,1-5,5H9a5.00181,5.00181,0,0,1-5-5V34a1.03276,1.03276,0,0,1,.29-.71l2-2a1.0021,1.0021,0,0,1,1.16-.18L9,31.88l2.01-1L9.45,29.83a.96191.96191,0,0,1-.4-.51l-.87-2.61L4.55,24.89A.97715.97715,0,0,1,4,24V5A3.00879,3.00879,0,0,1,7,2H35a3.00879,3.00879,0,0,1,3,3V16h5A3.00879,3.00879,0,0,1,46,19ZM9,15a.99974.99974,0,0,0,1,1H32a.99974.99974,0,0,0,1-1V8a.99974.99974,0,0,0-1-1H10A.99974.99974,0,0,0,9,8Zm17,6a1,1,0,0,0,0-2H10a1,1,0,0,0,0,2Zm7,16a.99974.99974,0,0,0-1-1H10a.99974.99974,0,0,0-1,1v6a.99974.99974,0,0,0,1,1H32a.99974.99974,0,0,0,1-1Zm0-4a.99974.99974,0,0,0-1-1H18a1,1,0,0,0,0,2H32A.99974.99974,0,0,0,33,33Zm0-4a.99974.99974,0,0,0-1-1H18a1,1,0,0,0,0,2H32A.99974.99974,0,0,0,33,29Zm2.64258-10a.99974.99974,0,0,0-1-1H33a1.00172,1.00172,0,0,0-.78125.37549l-4,5a1.00043,1.00043,0,0,0,.15625,1.40527,1.0108,1.0108,0,0,0,1.40625-.15625l.734-.9176.5365,1.6095a.99964.99964,0,1,0,1.89648-.63282l-.94543-2.8363L33.48047,20h1.16211A.99974.99974,0,0,0,35.64258,19ZM44,19a1.003,1.003,0,0,0-1-1H38V43a3,3,0,0,0,6,0Z",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorningReport);
export default __webpack_public_path__ + "static/media/morningReport.4ba3a79602e4c37381267f3a05baf071.svg";
export { ForwardRef as ReactComponent };